var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStocklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 2C5.57531 2.00009 5.4037 2.04594 5.25223 2.13298C5.10077 2.22002 4.97475 2.34521 4.88672 2.49609L3.13672 5.49609C3.04733 5.64899 3.00015 5.82289 3 6V18C3 19.0931 3.90694 20 5 20H19C20.0931 20 21 19.0931 21 18V6C20.9999 5.82289 20.9527 5.64899 20.8633 5.49609L19.1133 2.49609C19.0252 2.34521 18.8992 2.22002 18.7478 2.13298C18.5963 2.04594 18.4247 2.00009 18.25 2H5.75ZM6.32422 4H17.6758L18.8418 6H5.1582L6.32422 4ZM5 8H19V18H5V8ZM9 10V12H15V10H9Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocklist);
export default __webpack_public_path__ + "static/media/stocklist.ab657e2d9a0fb8c1b7c3189989c9ed44.svg";
export { ForwardRef as ReactComponent };